export default __webpack_public_path__ + "static/media/schedule-2.c8c180f1.svg";